import { useState } from "react";
import { motion } from "framer-motion";
import { ArrowUpRight, ShieldCheck } from "lucide-react";
import { TINT_LEVELS, TINT_IMAGES } from "../data";
import { useI18n } from "../i18n";

export const WindowTint = ({ onQuote }) => {
  const { t } = useI18n();
  const [active, setActive] = useState("35%");

  return (
    <section id="vitres" data-testid="tint-section" className="relative py-28 md:py-36 px-6 md:px-10 bg-[#070809] border-y border-cyan-500/10">
      <div className="max-w-[1400px] mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16 items-center">
          <motion.div
            initial={{ opacity: 0, x: -30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.7 }}
            className="space-y-4"
          >
            <div className="overflow-hidden rounded-2xl border border-white/10 aspect-[16/10]">
              <img src={TINT_IMAGES.chart} alt="VLT tint levels" loading="lazy" className="w-full h-full object-cover" />
            </div>
            <div className="grid grid-cols-2 gap-4">
              <div className="overflow-hidden rounded-2xl border border-white/10">
                <img src={TINT_IMAGES.result} alt="Tinted car" loading="lazy" className="w-full h-full object-cover aspect-[4/3]" />
              </div>
              <div className="overflow-hidden rounded-2xl border border-white/10">
                <img src={TINT_IMAGES.vlt} alt="VLT levels" loading="lazy" className="w-full h-full object-cover aspect-[4/3]" />
              </div>
            </div>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, x: 30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.7, delay: 0.1 }}
          >
            <span className="font-mono-accent text-xs uppercase tracking-[0.3em] text-cyan">{t("tint.tag")}</span>
            <h2 className="font-display font-700 uppercase tracking-tighter text-4xl md:text-6xl mt-4 leading-none">
              {t("tint.title1")} <span className="text-cyan neon-text-glow">{t("tint.title2")}</span>
            </h2>
            <p className="text-neutral-400 font-light mt-5 text-lg">{t("tint.subtitle")}</p>

            <div className="mt-8">
              <span className="font-mono-accent text-xs uppercase tracking-[0.2em] text-neutral-500">{t("tint.vltLabel")}</span>
              <div className="flex flex-wrap gap-2 mt-3">
                {TINT_LEVELS.map((lvl) => (
                  <button
                    key={lvl}
                    data-testid={`tint-level-${lvl.replace("%", "")}`}
                    onClick={() => setActive(lvl)}
                    className={`font-mono-accent text-sm px-4 py-2 rounded-full border transition-all duration-300 ${
                      active === lvl ? "text-black border-transparent" : "text-neutral-300 border-white/15 hover:border-cyan-400/50"
                    }`}
                    style={active === lvl ? { backgroundColor: "#C9A96A" } : {}}
                  >
                    {lvl}
                  </button>
                ))}
              </div>
            </div>

            <p className="text-neutral-500 text-sm font-light mt-6 flex items-start gap-2">
              <ShieldCheck size={16} className="text-cyan shrink-0 mt-0.5" /> {t("tint.note")}
            </p>

            <button
              data-testid="tint-cta"
              onClick={onQuote}
              className="mt-8 inline-flex items-center gap-3 text-black font-medium text-base px-7 py-4 rounded-full neon-glow hover:brightness-110 transition-all duration-300"
              style={{ backgroundColor: "#C9A96A" }}
            >
              {t("tint.cta")} ({active})
              <ArrowUpRight size={18} />
            </button>
          </motion.div>
        </div>
      </div>
    </section>
  );
};
